import React from 'react'
import Footer from './Footer'
import NavBar from './NavBar'
import Profile from './Profile'

export default function Home() {
    return (
        <div >
            <section id="Home">
                <NavBar />
                <Profile />
                <Footer />
            </section>
        </div>
    )
}
